import React, { useEffect } from 'react'

const Error404Page = props => {
  useEffect(() => {
    document.title = 'გვერდი ვერ მოიძებნა'
  }, [])

  return (
    <div className="flex flex-col items-center justify-center pt-32">
      <h1 className="text-6xl">404</h1>
      <h3 className="text-3xl">გვერდი ვერ მოიძებნა</h3>
    </div>
  )
}

export default Error404Page
